import { render, staticRenderFns } from "./AddressFormFields.vue?vue&type=template&id=164b6bb8&scoped=true"
import script from "./AddressFormFields.vue?vue&type=script&lang=ts"
export * from "./AddressFormFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b6bb8",
  null
  
)

export default component.exports